import { CssBaseline, ThemeProvider } from "@mui/material";
import { StyledEngineProvider } from "@mui/material/styles";
import { FC } from "react";
import { Toaster } from "react-hot-toast";
import { useRoutes } from "react-router-dom";
import { ConfigProvider } from "antd";
import routes from "./routes/routes";
import { parishTheme } from "./theme";
import { antdTheme } from "./theme/antdTheme";
import { error, success } from "./theme/themeColors";
import InternetConnection from "./components/UI/InternetConnection";

const App: FC = () => {
  const allPages = useRoutes(routes);
  const appTheme = parishTheme();

  const toasterOptions = {
    style: {
      fontWeight: 500,
      fontFamily: "'Montserrat', sans-serif",
      fontSize: 13,
      borderRadius: 10,
      boxShadow: "0px 8px 24px rgba(15,23,42,0.10)",
    },
    success: { iconTheme: { primary: success.main, secondary: "#fff" } },
    error: { iconTheme: { primary: error.main, secondary: "#fff" } },
  };

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={appTheme}>
        <ConfigProvider theme={antdTheme}>
          <CssBaseline />
          <InternetConnection />
          <Toaster toastOptions={toasterOptions} position="top-right" />
          {allPages}
        </ConfigProvider>
      </ThemeProvider>
    </StyledEngineProvider>
  );
};

export default App;
